/* ──────────────────────────────────────────────────────────────
 *  OutputPanel — Card3 Top (Right Column)

 *    1. Header: "Sample" title + search
 *    2. Scrollable body: Table + Shore A slider
 *    3. Footer: Export action buttons (Synera, Marc, PDF, PPT)
 * ────────────────────────────────────────────────────────────── */

import React from 'react';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ACCENT_COLOR } from '@/constants/colors';

import { useSampleStore } from '@/stores/useSampleStore';

import SampleTable from './SampleTable';
import SearchBar from './SearchBar';
import OutputShoreSlider from './OutputShoreSlider';
import MoreActionsMenu from './MoreActionsMenu';
import ExportStatusPanel from './ExportStatusPanel';

const OutputPanel: React.FC = () => {
  const currentSelectedId = useSampleStore((s) => s.currentSelectedId);

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        borderRadius: '14px',
        background: 'rgba(255,255,255,0.9)',
        overflow: 'hidden',
        minHeight: 0,
        gap: 1,
        p: 1.5,
      }}
    >
      {/* ── Header ──────────────────────────────────────── */}

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          flexWrap: 'wrap',
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 700, fontSize: '0.875rem', color: ACCENT_COLOR }}
        >
          {currentSelectedId ? `Sample - ${currentSelectedId}` : 'Sample'}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <SearchBar />
          <MoreActionsMenu />
        </Box>
      </Box>

      {/* ── Scrollable body: Table + Shore slider ───────── */}
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        <SampleTable />
        <OutputShoreSlider />
      </Box>

      {/* ── Footer: Export action buttons ───────────────── */}
      <ExportStatusPanel />
    </Card>
  );
};

export default React.memo(OutputPanel);
